import { useState } from "react";

export default function Logo() {
  const [isImageValid, setIsImageValid] = useState(true);

  if (isImageValid) {
    return (
      <img
        src="/logo.png"
        alt="Logo"
        onError={() => setIsImageValid(false)}
        style={{ maxWidth: "200px", maxHeight: "50px", display: "flex", margin: "auto" }}
      />
    );
  }

  return null;
}
